module.exports = __webpack_public_path__ + "img/yarus.f5558028.svg";